module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./PayPwdView.js"));
	}, "PayPwdView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PayPwdView!./src/pages/Shop/Member/Wallet/PayPwd/PayPwdView.js
// module id = 1072
// module chunks = 431